module.exports = __webpack_public_path__ + "img/pin-gps@3x.e19a991e.png";